import { MenuItem, Select } from "@mui/material";
import { Button } from "components/atoms/Button";
import { Delete } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import MUITheme from "components/MUITheme";
import { useFeatureFlagEnabled } from "posthog-js/react";

const FUELS = [
    { value: "electricity", label: "Electricity" },
    { value: "natural_gas", label: "Natural gas" },
    { value: "steam", label: "Steam" },
];

function CarbonIntensityReductionEffectInput({
    carbonIntensityReductionInputs,
    setCarbonIntensityReductionInputs,
}: {
    carbonIntensityReductionInputs: CarbonIntensityReductionEffect[];
    setCarbonIntensityReductionInputs: (inputs: CarbonIntensityReductionEffect[]) => void;
}) {
    const featureEnabled = useFeatureFlagEnabled("consumption-reduction-measure-effect");
    const newInput = () => {
        setCarbonIntensityReductionInputs([
            ...carbonIntensityReductionInputs,
            {
                uid: crypto.randomUUID(),
                // Arbitrary ID is provided to object as it has not been saved to
                // a databse yet.
                id: 0,
                fuel: "",
                percentReduction: null,
            },
        ]);
    };
    const handleChange = (id: string, field: string, value: string | number | null) => {
        const newValues = carbonIntensityReductionInputs.map((inputObj) =>
            inputObj.uid === id ? { ...inputObj, [field]: value } : inputObj
        );
        setCarbonIntensityReductionInputs(newValues);
    };
    const removeInput = (uid: string) => {
        setCarbonIntensityReductionInputs(carbonIntensityReductionInputs.filter((input) => input.uid !== uid));
    };
    if (!featureEnabled) {
        return null;
    }
    return (
        <div>
            {carbonIntensityReductionInputs.map((inputObj) => (
                <div key={inputObj.uid} className="effect-container">
                    <div className="effect-header">
                        <Header size="medium">Carbon intensity reduction</Header>
                        <Button onClick={() => removeInput(inputObj.uid)} icon={<Delete />} />
                    </div>
                    <Header size="small">Fuel</Header>
                    <MUITheme primaryColor="#EB03AD">
                        <Select
                            required
                            value={inputObj.fuel}
                            onChange={(e) => handleChange(inputObj.uid, "fuel", e.target.value || "")}
                            style={{
                                width: "100%",
                                height: "35px",
                                minWidth: 0,
                                backgroundColor: "white",
                            }}
                        >
                            {FUELS.map((unit) => (
                                <MenuItem key={unit.value} value={unit.value}>
                                    {unit.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </MUITheme>
                    <Header size="small">Reduction percentage</Header>
                    <input
                        key="consumptionReductionPercentage"
                        required={false}
                        type="number"
                        value={inputObj.percentReduction || ""}
                        className="filter-input"
                        onWheel={(e) => e.currentTarget.blur()}
                        onChange={(e) => {
                            const value = e.target.value === null ? null : Number(e.target.value);
                            handleChange(inputObj.uid, "percentReduction", value);
                        }}
                        placeholder="Enter the percentage of load reduction"
                    />
                </div>
            ))}
            <div className="filter-container">
                <Button type="primary" onClick={newInput}>
                    + Add carbon intensity reduction
                </Button>
            </div>
        </div>
    );
}

export default CarbonIntensityReductionEffectInput;
